export const GET_COINDATA = "GET_COINDATA";
export const GET_LOADER = "GET_LOADER";
export const GET_MODE = "GET_MODE";